<template>
  <div>
    <mt-header fixed :style="headerStyle">
      <div slot="left">
        <div class="logo" @click="handleHome"></div>
      </div>
      <div class="right-box" slot="right">
        <div class="lang" @click="handleLang">
          <span>{{ this.$t('lang') }}</span>
        </div>
        <el-button
          class="el-button--special round bold up"
          size="sm"
          v-if="!this.$store.state.token"
          @click="handleLogin"
          >{{ $t('login') }}</el-button
        >
        <div
          class="h-account"
          v-else
          @click="handleRoute(`/${$store.state.role}/account`)"></div>
        <div class="h-menu" @click="handleToggleMenu" v-if="!hideNav"></div>
      </div>
    </mt-header>
    <mt-popup v-model="popupVisibleTop" position="top">
      <ul class="nav-box">
        <li
          v-for="(item, index) in this.$store.state.navList"
          :key="index"
          @click="handleNav(item)">
          {{ item.label }}
        </li>
      </ul>
    </mt-popup>
    <GameView v-if="showGame" :gameover-c-b="gameFinish"></GameView>
    <mt-popup
      v-model="popupVisible"
      position="bottom"
      :closeOnClickModal="false">
      <Login v-if="popType === 'login'" @handleLoginBack="handleLoginBack" />
      <div class="pop-box select" v-if="popType === 'lang'">
        <div class="pop-title">{{ $t('chooselanguage') }}</div>
        <ul>
          <li
            v-for="(item, index) in list"
            :key="index"
            @click="handleSelect(item)"
            :class="item.selected ? 'selected' : ''">
            <span>{{ item.label }}</span>
          </li>
        </ul>
      </div>
      <div
        class="pop-close"
        @click="
          () => {
            this.popupVisible = false
          }
        "></div>
    </mt-popup>
    <div class="welcome-page" v-if="showWelcome">
      <div class="dv">
        <div class="tit">{{ $t('add.text56') }}</div>
        <div class="sub-tit" v-html="$t('add.text57')"></div>
        <img src="@/assets/images/welcome.png" />
        <div class="ded" v-html="$t('add.text58')"></div>
        <div style="margin: 0 0.27rem">
          <el-button class="el-button--special block" @click="handleWelcome">{{
            $t('add.text59')
          }}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import GameView from '@/components/GameView.vue'
import Login from '@/components/Login.vue'

export default {
  components: {
    Login,
    GameView
  },
  props: {
    hideNav: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      unSigned: true,
      popupVisible: false,
      popupVisibleTop: false,
      list: [],
      popType: null,
      headerStyle: {},
      currentLangItem: null,
      showGame: false,
      showWelcome: false,
      tokenPath: ['/user/account', '/user/income']
    }
  },
  watch: {
    popupVisible: {
      handler(n) {
        if (n) {
          this.headerStyle = {}
        }
        this.$stopScroll(n)
      },
      deep: true
    },
    '$i18n.locale'() {
      this.init()
    }
  },
  created() {
    this.$bus.on('handleLogin', () => {
      this.handleLogin()
    })
    this.init()
  },
  activated() {
    this.popupVisibleTop = false
  },
  methods: {
    init() {
      let list = [
        {
          label: this.$t('english'),
          value: 'en'
        },
        {
          label: this.$t('vietnamese'),
          value: 'vi'
        },
        {
          label: this.$t('add.chinese'),
          value: 'cn'
        },
        {
          label: this.$t('japanese'),
          value: 'ja'
        }
      ]
      if (this.currentLangItem) {
        this.list = list.map((e) => {
          if (e.value === this.currentLangItem.value) {
            e.selected = true
          } else {
            e.selected = false
          }
          return e
        })
      } else {
        this.list = list.map((e) => {
          if (e.value === this.$store.state.lang) {
            e.selected = true
          } else {
            e.selected = false
          }
          return e
        })
      }
    },
    handleWelcome() {
      this.showWelcome = false
      this.handleRoute('/user/howtoplay')
    },
    handleLogin() {
      this.popType = 'login'
      this.popupVisible = true
    },
    handleLoginBack(val) {
      if (this.$store.state.role === 'user' && val) {
        this.showGame = true
      }
      console.log(888888888)
      console.log(val)
      this.popupVisible = false
      this.popupVisibleTop = false
      console.log(this.popupVisible)
      this.$emit('refreshPage')
    },
    handleToggleMenu() {
      if (this.popupVisibleTop) {
        this.popupVisibleTop = !this.popupVisibleTop
        setTimeout(() => {
          this.headerStyle = {}
        }, 200)
      } else {
        this.headerStyle = {
          zIndex: 3333
        }
        this.popupVisibleTop = !this.popupVisibleTop
      }
    },
    handleNav(item) {
      if (this.tokenPath.indexOf(item.route) > -1 && !this.$store.state.token) {
        this.popupVisibleTop = false
        this.handleLogin()
      } else {
        this.popupVisibleTop = false
        this.$router.push({ path: item.route })
      }
    },
    handleLang() {
      this.popType = 'lang'
      this.popupVisible = true
    },
    handleSelect(item) {
      this.currentLangItem = item
      this.$store.dispatch('setLang', item.value)
      this.$i18n.locale = item.value
      this.$store.dispatch('setRole')
      this.popupVisible = false
    },
    handleHome() {
      this.$router.push({ path: '/' })
    },
    handleRoute(path) {
      this.$router.push({ path: path })
    },
    gameFinish() {
      this.showWelcome = true
    }
  }
}
</script>
<style lang="scss">
.logo {
  background: url(~@/assets/images/logo.svg) no-repeat center center;
  background-size: auto 0.2rem;
  height: 0.2rem;
  min-width: 0.77rem;
}
.right-box {
  display: flex;
  align-items: center;
  .lang {
    border-radius: 1rem;
    background-color: rgba(255, 255, 255, 0.07);
    margin-right: 0.15rem;
    span {
      background: url(~@/assets/images/lang.svg) no-repeat 0.1rem center;
      background-size: auto 0.15rem;
      display: inline-block;
      padding: 0.07rem 0.1rem 0.07rem 0.3rem;
    }
  }
}
.h-menu {
  background: url(~@/assets/images/menu.svg) no-repeat center center;
  background-size: auto 0.2rem;
  height: 0.2rem;
  width: 0.2rem;
  margin-left: 0.23rem;
}
.h-account {
  background: url(~@/assets/images/account.svg) no-repeat center center;
  background-size: auto 0.3rem;
  height: 0.3rem;
  width: 0.3rem;
}
.nav-box {
  background-color: #2a2a2a;
  padding: 0 0.2rem;
  text-align: center;
  text-transform: uppercase;
  &.hide {
    display: none;
  }
  li {
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
    font-size: 0.24rem;
    font-weight: bold;
    padding: 0.16rem 0;
  }
}

.welcome-page {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  text-align: center;
  background-color: #121212;
  display: flex;
  align-items: center;
  .dv {
    margin: 0 auto;
  }
  .tit {
    font-family: 'Montserrat';
    font-size: 0.2rem;
    font-weight: 700;
    color: #ffcf71;
  }
  .sub-tit {
    color: rgba(255, 255, 255, 0.6);
    margin: 0.1rem 0.57rem 0;
    span {
      color: #ffcf71;
    }
  }
  img {
    width: 100%;
    margin: 0.5rem 0;
  }
  .ded {
    margin: 0 0.24rem 0.14rem;
    font-size: 0.16rem;
    font-weight: 600;
    line-height: 0.24rem;
    span {
      color: #ffcf71;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue